/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class MemberDiscount extends Mb {
    constructor() {
        super();
        this.baseUrl += '/memberDiscount';
    }

    data({
        memberDiscountSn,
        memberDiscountName,
        orgId,
        writeOffEndTime,
        memberDiscountStatus,
        schoolOrgId,
        currentPage,
        pageSize,
    } = {}) {
        let writeOffEndBeginTime = null;
        let writeOffEndEndTime = null;
        if (writeOffEndTime != null && writeOffEndTime.length === 2) {
            [writeOffEndBeginTime, writeOffEndEndTime] = writeOffEndTime;
        }
        return super.get('/data', {
            memberDiscountSn,
            memberDiscountName,
            orgId,
            writeOffEndBeginTime,
            writeOffEndEndTime,
            memberDiscountStatus,
            schoolOrgId,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            return json;
        });
    }

    save({
        id,
        memberDiscountSn,
        memberDiscountName,
        orgId,
        writeOffEndTime,
        remarks,
        schoolOrgId,
        skuJson,
        type,
        cooperationMemberListJson,
    } = {}) {
        return super.post(
            '/save',
            {
                id,
                memberDiscountSn,
                memberDiscountName,
                orgId,
                writeOffEndTime,
                remarks,
                schoolOrgId,
                skuJson,
                type,
                cooperationMemberListJson,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    end({ ids } = {}) {
        return super.post('/end', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }
}

export default new MemberDiscount();
export { MemberDiscount };
